function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { TransitionMotion, spring } from 'react-motion';
import PropTypes from 'prop-types';

var enter = {
  y: -50
};

var leave = {
  y: spring(-100)
};

var defaultTransitionMotionStyles = [{
  key: 'modal',
  style: { y: -100 }
}];

var transitionMotionStyles = {
  key: 'modal',
  style: { y: spring(0) }
};

var TransitionMotionModal = function (_React$Component) {
  _inherits(TransitionMotionModal, _React$Component);

  function TransitionMotionModal() {
    var _temp, _this, _ret;

    _classCallCheck(this, TransitionMotionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.willEnter = function () {
      return _this.props.enter ? _this.props.enter : enter;
    }, _this.willLeave = function () {
      return _this.props.leave ? _this.props.leave : leave;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TransitionMotionModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.show && !this.props.show && this.props.fullScreen) {
      document.body.style.overflow = '';
      document.body.style.height = '';
    }
  };

  TransitionMotionModal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (nextProps.fullScreen && nextProps.show) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    }
  };

  TransitionMotionModal.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        customClose = _props.customClose,
        customClass = _props.customClass,
        defaultTransitionStyles = _props.defaultTransitionStyles,
        outerStyle = _props.outerStyle,
        itemsStyle = _props.itemsStyle,
        show = _props.show,
        toggle = _props.toggle,
        transitionStyles = _props.transitionStyles;


    var styles = show ? ['modal'] : [];

    return React.createElement(
      TransitionMotion,
      {
        defaultStyles: defaultTransitionStyles ? defaultTransitionStyles : defaultTransitionMotionStyles,
        styles: styles.map(function (s) {
          return transitionStyles ? transitionStyles : transitionMotionStyles;
        }),
        willEnter: this.willEnter,
        willLeave: this.willLeave },
      function (items) {
        return React.createElement(
          'div',
          { style: outerStyle },
          items.map(function (s) {
            return React.createElement(
              'div',
              {
                key: s.key,
                className: customClass,
                style: itemsStyle ? itemsStyle : { transform: 'translate3d(0,' + s.style.y + '%,0)' } },
              !customClose && React.createElement(
                'div',
                { className: 'menu-modal-dismiss' },
                React.createElement('i', { className: 'fa fa-2x fa-times', onClick: toggle })
              ),
              _this2.props.children
            );
          })
        );
      }
    );
  };

  return TransitionMotionModal;
}(React.Component);

export { TransitionMotionModal as default };


TransitionMotionModal.PropTypes = {
  customClose: PropTypes.bool,
  customClass: PropTypes.string,
  enter: PropTypes.obj,
  outerStyle: PropTypes.obj,
  itemsStyle: PropTypes.obj,
  leave: PropTypes.obj,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  transitionDefaultStyles: PropTypes.obj,
  transitionStyles: PropTypes.obj,
  fullScreen: PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ../transitionmotion-modal/es/index.js
// module id = 403
// module chunks = 4